module.exports = __webpack_public_path__ + "18898ef1cbd773a338cb64ada80b441d.png";